import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

const apiUrl = `${settings.apiUrl}api/`;

export const requestNoPagination = (filters) =>
  axios.post(`${apiUrl}tag/list`, {
    criteria: filters
  });

export const requestSingle = (tagId) =>
  axios.post(`${apiUrl}tag/search?page=0&size=1`, {
    criteria: [{
      fieldName: "id",
      fieldValue: tagId,
      searchOperation: filterTypes.EQUALS.value
    }]
  });

export const requestAddTag = (data) =>
  axios.post(`${apiUrl}tag`, data);

export const requestGetTypes = () =>
  axios.get(`${apiUrl}tag/types`);



// WEBPACK FOOTER //
// ./src/actions/tag/requests.js